// @flow
import { subscribe } from "@tvg/mediator-classic/src";
import type { Store } from "redux";
import CONSTANTS from "./constants";

export default (store: Store<*, *>) => {
  subscribe(CONSTANTS["TVG_LOGIN:USER_SESSION_UPDATE"], (newState) => {
    store.dispatch({
      type: CONSTANTS.UPDATE_USER_DATA,
      payload: newState
    });
  });
  return store;
};
